// import $ from 'jquery' // jQuery
import jQuery from 'jquery'
window.$ = window.jQuery = jQuery

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉

/* global  */ // tUrl等のグローバル変数を宣言する

import luxy from 'luxy.js'

import './_top.js'
import './_form.js'

import Swiper from 'swiper'
import { Autoplay, Controller, EffectFade, Navigation, Pagination } from 'swiper/modules'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
##     ## ########    ###    ########  ######## ########
##     ## ##        ##   ##  ##     ## ##       ##     ##
######### ######   ##     ## ##     ## ######   ########
##     ## ##       ######### ##     ## ##       ##   ##
##     ## ######## ##     ## ########  ######## ##     ##
*/
if (document.getElementById('header')) {
  const header = document.getElementById('header')
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      header.classList.add('fixed')
    } else {
      header.classList.remove('fixed')
    }
  })
}

//  ##      ##   ##  ##    ##  ##    ##
//  ##      ##   ##   ##  ##    ##  ##
//  ##      ##   ##    ####      ####
//  ##      ##   ##   ##  ##      ##
//  ######   #####   ##    ##     ##
if (document.getElementById('luxy') && window.matchMedia('(min-width:769px)').matches) {
  //PC
  luxy.init({
    wrapper: '#luxy',
    targets: '.luxy-el',
  })
}

if (document.getElementsByClassName('js-recruitContainer')[0] && window.matchMedia('(min-width:769px)').matches) {
  setRecrutContainerHeight()
}
function setRecrutContainerHeight() {
  console.log('setRecrutContainerHeight')
  const mainHeight = document.getElementsByClassName('js-recruitMain')[0].clientHeight
  document.getElementsByClassName('js-recruitContainer')[0].style.height = mainHeight + 'px'
}

if (document.getElementsByClassName('js-recruitSide')[0] && window.matchMedia('(min-width:769px)').matches) {
  /**
   * 指定エリア内で要素を追従させる
   * @param {object} fixedElm 追従要素
   * @param {object} fixedArea 追従エリア
   */
  const areaFixedFunk = (fixedElm, fixedArea) => {
    const areas = document.querySelectorAll(fixedArea)
    if (areas.length === 0) {
      return
    }

    const checkFixed = (target, area) => {
      //要素の位置と高さを取得
      const startPosi = area.getBoundingClientRect().top
      const targetHeight = target.clientHeight
      const areaHeight = area.clientHeight
      const endPosi = startPosi + areaHeight

      const rect = area.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const topPos = rect.top + scrollTop

      console.log('topPos: ' + topPos)

      // //エリア内の処理
      // if (0 > startPosi && targetHeight < endPosi) {
      //   target.classList.add('fixed')
      //   target.style.top = ''

      //   //エリアより上の処理
      // } else if (0 <= startPosi) {
      //   target.classList.remove('fixed')
      //   target.style.top = ''

      //   //エリアより下の処理
      // } else {
      //   target.classList.remove('fixed')
      //   //停止位置を設定
      //   target.style.top = areaHeight - targetHeight + 'px'
      // }
    }

    //エリア毎に処理
    areas.forEach((area) => {
      //エリア内に追従要素が存在する場合のみ処理する
      const target = area.querySelector(fixedElm)
      if (target) {
        checkFixed(target, area)
        window.addEventListener('resize', () => {
          checkFixed(target, area)
        })
        window.addEventListener(
          'scroll',
          () => {
            checkFixed(target, area)
          },
          { passive: true }
        )
      }
    })
  }
  // areaFixedFunk('.js-recruitSide-items', '.js-recruitSide')
}

/* マウスストーカー */
const stalker = document.getElementById('mouseStalker')
const linkElem = document.getElementsByClassName('js-contactLink')
if (window.matchMedia('(min-width:769px)').matches && linkElem[0]) {
  document.addEventListener('mousemove', function (e) {
    stalker.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)'
  })
  for (let i = 0; i < linkElem.length; i++) {
    linkElem[i].addEventListener('mouseover', function (e) {
      stalker.classList.add('hover')
    })
    linkElem[i].addEventListener('mouseout', function (e) {
      stalker.classList.remove('hover')
    })
  }
}

/* アコーディオン */
if (document.getElementsByClassName('js-acc')[0]) {
  const items = document.getElementsByClassName('js-acc')
  for (let item of items) {
    item.addEventListener(`click`, () => {
      const content = item.nextElementSibling
      item.classList.toggle('open')
      if (item.classList.contains('open')) {
        content.style.height = content.scrollHeight + 'px'
      } else {
        content.style.height = 0
      }
      if (document.getElementsByClassName('js-recruitContainer')[0] && window.matchMedia('(min-width:769px)').matches) {
        setRecrutContainerHeight()
      }
    })
  }
}
if (document.getElementsByClassName('js-attractiveAcc')[0]) {
  if (window.matchMedia('(max-width:768px)').matches) {
    const items = document.getElementsByClassName('js-attractiveAcc')
    for (let item of items) {
      const head = item.children[0]
      head.addEventListener(`click`, () => {
        const content = head.nextElementSibling
        item.classList.toggle('open')
        if (item.classList.contains('open')) {
          content.style.height = content.scrollHeight + 'px'
        } else {
          content.style.height = 0
        }
      })
    }
  }
}
if (document.getElementsByClassName('js-accColumn')[0]) {
  if (window.matchMedia('(max-width:768px)').matches) {
    const items = document.getElementsByClassName('js-accColumn')
    for (let item of items) {
      item.addEventListener(`click`, () => {
        const content = item.nextElementSibling
        item.classList.toggle('open')
        if (item.classList.contains('open')) {
          content.style.height = content.scrollHeight + 'px'
        } else {
          content.style.height = 0
        }
      })
    }
  }
}

if (document.getElementsByClassName('js-topMv-video')[0]) {
  if (window.matchMedia('(max-width:768px)').matches) {
    const video = document.getElementsByClassName('js-topMv-video')[0]
    const img = document.getElementsByClassName('js-topMv-img')[0]
    video.addEventListener(
      'play',
      function () {
        img.classList.toggle('hide')
      },
      true
    )
  }
}

/*
 ######  ##       #### ########  ########
##       ##        ##  ##     ## ##
 ######  ##        ##  ##     ## ######
      ## ##        ##  ##     ## ##
 ######  ######## #### ########  ########
*/
if (document.getElementsByClassName('js-consultant-slider')[0]) {
  const slideName = '.js-consultant-slider'
  // eslint-disable-next-line no-unused-vars
  const topConsultantSlide = new Swiper(slideName, {
    speed: 6000,
    // createElements: true,
    loop: true,
    autoplay: {
      delay: 0,
    },
    slidesPerView: 'auto',
    spaceBetween: 0,
    breakpoints: {
      // when window width is >= 769px
      769: {
        // speed: 6000,
      },
    },
    // navigation: {
    //   nextEl: slideName + '-next',
    //   prevEl: slideName + '-prev',
    // },
    // pagination: {
    //   el: slideName + '-pagination',
    //   type: 'fraction',
    // },
  })
}

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
if (document.getElementsByClassName('js-in')[0]) {
  // 画面に入った監視対象に.animatedを付加
  // Intersection Observer
  intObs()
}
function intObs() {
  let rootMargin = '-10px 0px'
  if (window.matchMedia('(max-width:768px)').matches) {
    //SPは検出を早くする
    rootMargin = '100px 0px'
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
